import axios from 'axios';
import { getHeaders } from '../utils/getHeaders';
import { encryptData, getUserRole } from '../helpers/common-helper';

let isModalOpen = false;
let loginQueue = [];
let refreshTokenPromise = null;

const promptNcdLogin = (originalConfig) => {
  return new Promise((resolve, reject) => {
    loginQueue.push({ originalConfig, resolve, reject });

    if (isModalOpen) return;
    isModalOpen = true;

    // Create Modal HTML element
    const modalDiv = document.createElement('div');
    modalDiv.id = 'ncd-reauth-modal';
    modalDiv.style.position = 'fixed';
    modalDiv.style.top = '0';
    modalDiv.style.left = '0';
    modalDiv.style.width = '100%';
    modalDiv.style.height = '100%';
    modalDiv.style.display = 'flex';
    modalDiv.style.alignItems = 'center';
    modalDiv.style.justifyContent = 'center';
    modalDiv.style.background = 'rgba(0, 0, 0, 0.65)';
    modalDiv.style.backdropFilter = 'blur(5px)';
    modalDiv.style.zIndex = '99999';

    modalDiv.innerHTML = `
      <div class="modal-dialog modal-dialog-centered" style="width: 100%; max-width: 500px; margin: 1.75rem; box-sizing: border-box; text-align: left;">
        <div class="modal-content border-0 shadow-lg" style="border-radius: 12px; overflow: hidden; background-color: #fff; display: flex; flex-direction: column; width: 100%; box-shadow: 0 15px 35px rgba(0,0,0,0.25); border: none;">
          <!-- Header -->
          <div class="modal-header" style="background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); color: white; border-bottom: none; padding: 20px; display: flex; align-items: center; justify-content: space-between;">
            <h5 class="modal-title m-0 fw-bold" style="font-size: 1.25rem; font-family: inherit; font-weight: 700; margin: 0; color: white; text-align: left;">NCD Session Expired</h5>
            <button type="button" class="btn-close btn-close-white" id="ncd-reauth-close-btn" style="box-shadow: none; border: none; background: transparent; color: white; font-size: 1.5rem; cursor: pointer; padding: 0; line-height: 1;">&times;</button>
          </div>
          
          <!-- Body -->
          <div class="modal-body" style="padding: 30px 25px; background-color: #fcfdfe; text-align: left;">
            <p class="text-muted" style="font-size: 0.95rem; margin-top: 0; margin-bottom: 25px; color: #6c757d; line-height: 1.5; text-align: left;">
              Your NCD session has expired. Please enter your credentials to log in again and resume your activity.
            </p>
            
            <form id="ncd-reauth-form" style="text-align: left; display: block; width: 100%;">
              <!-- Username Field -->
              <div class="mb-3" style="margin-bottom: 20px; text-align: left; display: block; width: 100%;">
                <label for="ncd-reauth-email" class="form-label" style="font-size: 0.85rem; display: block; margin-bottom: 8px; font-weight: 600; color: #495057; text-align: left;">Username</label>
                <input type="text" id="ncd-reauth-email" placeholder="Enter your email or username" required style="border-radius: 8px; padding: 12px 16px; width: 100%; border: 1px solid #ced4da; box-sizing: border-box; font-size: 0.95rem; text-align: left; background-color: #ffffff; color: #495057; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;" />
              </div>
              
              <!-- Password Field -->
              <div class="mb-3" style="margin-bottom: 20px; text-align: left; display: block; width: 100%;">
                <label for="ncd-reauth-password" class="form-label" style="font-size: 0.85rem; display: block; margin-bottom: 8px; font-weight: 600; color: #495057; text-align: left;">Password</label>
                <input type="password" id="ncd-reauth-password" placeholder="Enter your password" required style="border-radius: 8px; padding: 12px 16px; width: 100%; border: 1px solid #ced4da; box-sizing: border-box; font-size: 0.95rem; text-align: left; background-color: #ffffff; color: #495057; transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;" />
              </div>
              
              <!-- Error Message Area -->
              <div id="ncd-reauth-error" class="alert alert-danger d-none" role="alert" style="border-radius: 8px; font-size: 0.9rem; padding: 12px 15px; color: #721c24; background-color: #f8d7da; border-color: #f5c6cb; margin-bottom: 20px; text-align: left;"></div>
              
              <!-- Action Buttons -->
              <div style="display: flex; gap: 12px; justify-content: flex-end; align-items: center; margin-top: 25px; width: 100%;">
                <button type="button" id="ncd-reauth-cancel-btn" style="border-radius: 8px; font-weight: 600; padding: 12px 24px; border: 1px solid #ced4da; background: #ffffff; color: #6c757d; cursor: pointer; font-size: 0.95rem; transition: all 0.2s ease-in-out;">Cancel</button>
                <button type="submit" id="ncd-reauth-submit-btn" style="border-radius: 8px; font-weight: 600; padding: 12px 24px; background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); border: none; color: white; cursor: pointer; display: flex; align-items: center; gap: 8px; font-size: 0.95rem; transition: all 0.2s ease-in-out; box-shadow: 0 4px 6px rgba(42, 82, 152, 0.25);">
                  <span id="ncd-reauth-btn-text">Log In</span>
                  <span id="ncd-reauth-btn-spinner" class="spinner-border spinner-border-sm d-none" role="status" aria-hidden="true" style="width: 1rem; height: 1rem; border: 0.15em solid currentColor; border-right-color: transparent; border-radius: 50%; display: inline-block; animation: spinner-border .75s linear infinite;"></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <style>
        @keyframes spinner-border {
          to { transform: rotate(360deg); }
        }
        .d-none { display: none !important; }
        #ncd-reauth-email:focus, #ncd-reauth-password:focus {
          border-color: #2a5298 !important;
          outline: none !important;
          box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.15) !important;
        }
      </style>
    `;

    document.body.appendChild(modalDiv);

    const closeBtn = document.getElementById('ncd-reauth-close-btn');
    const cancelBtn = document.getElementById('ncd-reauth-cancel-btn');
    const form = document.getElementById('ncd-reauth-form');
    const emailInput = document.getElementById('ncd-reauth-email');
    const passwordInput = document.getElementById('ncd-reauth-password');
    const captchaInput = document.getElementById('ncd-reauth-captcha');
    const errorDiv = document.getElementById('ncd-reauth-error');
    const submitBtn = document.getElementById('ncd-reauth-submit-btn');
    const btnText = document.getElementById('ncd-reauth-btn-text');
    const btnSpinner = document.getElementById('ncd-reauth-btn-spinner');

    const handleDismiss = () => {
      modalDiv.remove();
      isModalOpen = false;
      
     // localStorage.clear();
      
      // // Reject all pending items in queue
      // loginQueue.forEach(item => {
      //   item.reject(new Error('Session expired and login cancelled'));
      // });
      // loginQueue = [];

      // window.location.href = '/login';
    };

    closeBtn.addEventListener('click', handleDismiss);
    cancelBtn.addEventListener('click', handleDismiss);

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const emailVal = emailInput.value.trim();
      const passwordVal = passwordInput.value;
      const captchaVal = '1234';//captchaInput.value.trim();

      // Show loading state
      submitBtn.disabled = true;
      cancelBtn.disabled = true;
      closeBtn.disabled = true;
      btnSpinner.classList.remove('d-none');
      btnText.textContent = 'Logging in...';
      errorDiv.classList.add('d-none');

      try {
        const encryptedEmail = encryptData(emailVal);
        const encryptedPassword = encryptData(passwordVal);

        const response = await axios.post("/nodeapi/ncd/login", {
          email: encryptedEmail,
          password: encryptedPassword,
          captcha: captchaVal
        }, {
          headers: {
            "x-encrypted": "true",
            ...getHeaders()
          }
        });

        if (response.status === 200 && response.data?.data?.access_token) {
          const data = response.data.data;

          const userdetail = {
            firstname: data.username,
            rolename: getUserRole(data.username),
            facilityName: data.facilityName,
            facilitydetail: `${data.facilityType}, ${data.facilityName}`,
            username: data.username,
            ncdusername: data.username,
            loginuser: data.user,
            stateCode: data.stateCode,
            facility: data.facility,
            facilityTypeId: data.facilityTypeId,
            facilityType: data.facilityType,
          };

          // Save tokens
          localStorage.setItem("NCD_token", data.access_token);
          localStorage.setItem("NCD_refresh_token", data.refresh_token);
          localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));
          localStorage.setItem("NCD_loggedinUserdetails", JSON.stringify(userdetail));
          localStorage.setItem("NCD_PERMISSIONS", JSON.stringify(response.data.permission));
          localStorage.setItem("ncd_username", data.username);

          // Dispatch event to sync sidebar and page headers
          window.dispatchEvent(new Event("userDetailsUpdated"));

          // Clean up modal
          modalDiv.remove();
          isModalOpen = false;

          // Retry all queued requests
          const updatedHeaders = getHeaders();
          loginQueue.forEach(item => {
            const retryConfig = { ...item.originalConfig };
            retryConfig.headers = { ...retryConfig.headers, ...updatedHeaders };
            // Retry request using Axios and resolve/reject original promise
            axios(retryConfig).then(item.resolve).catch(item.reject);
          });
          loginQueue = [];
        } else {
          throw new Error(response.data?.message || 'Invalid Username or Password');
        }
      } catch (err) {
        console.error("Re-authentication error:", err);
        errorDiv.textContent = err.response?.data?.message || err.message || 'Invalid Email or Password';
        errorDiv.classList.remove('d-none');
        
        // Reset button loading state
        submitBtn.disabled = false;
        cancelBtn.disabled = false;
        closeBtn.disabled = false;
        btnSpinner.classList.add('d-none');
        btnText.textContent = 'Log In';
      }
    });
  });
};



const createApiClient = (baseURL = '') => {
  const client = axios.create({
    baseURL,
    timeout: 30000,
  });

  client.interceptors.request.use(
    (config) => {
      const headers = getHeaders();
      config.headers = { ...config.headers, ...headers };
      return config;
    },
    (error) => Promise.reject(error)
  );

  const handleSessionExpired = async (responseData, originalConfig) => {
    if (responseData?.success === false || responseData?.message === "SESSION_EXPIRED") {
      try {
        if (!refreshTokenPromise) {
          const refreshUrl = '/nodeapi/ncd/refresh-token';
          const rtoken = localStorage.getItem('NCD_refresh_token');

          refreshTokenPromise = axios.post(refreshUrl, { rtoken }, {
            headers: getHeaders()
          }).then(res => {
            refreshTokenPromise = null;
            return res;
          }).catch(err => {
            refreshTokenPromise = null;
            throw err;
          });
        }

        const refreshResponse = await refreshTokenPromise;

        if (refreshResponse.data?.success) {
          localStorage.setItem("NCD_token", refreshResponse.data.data.access_token);
          localStorage.setItem("NCD_refresh_token", refreshResponse.data.data.refresh_token);
          
          const retryConfig = { ...originalConfig };
          retryConfig.headers = { ...retryConfig.headers, ...getHeaders() };
          return axios(retryConfig);
        } else {
          return promptNcdLogin(originalConfig);
        }
      } catch (refreshError) {
        return promptNcdLogin(originalConfig);
      }
    }
    return null;
  };

  client.interceptors.response.use(
    async (response) => {
      const retryResponse = await handleSessionExpired(response.data, response.config);
      return retryResponse || response;
    },
    async (error) => {
      if (error.response?.status === 401) {
        const retryResponse = await handleSessionExpired(error.response.data, error.config);
        if (retryResponse) return retryResponse;
      } else if (error.response?.data) {
        // Check for SESSION_EXPIRED in error response
        const retryResponse = await handleSessionExpired(error.response.data, error.config);
        if (retryResponse) return retryResponse;
      }

      // Handle 500 and other server errors gracefully
      if (error.response?.status >= 500) {
        return Promise.resolve({
          data: {
            success: false,
            message: error.response?.data?.message || 'Server error occurred. Please try again later.',
            error: true
          },
          status: error.response.status
        });
      }

      // Handle network errors and other errors
      console.error('API Error:', error.message);
      return Promise.resolve({
        data: {
          success: false,
          message: error.message || 'An error occurred',
          error: true
        }
      });
    }
  );

  return client;
};

export const nodeApiClient = createApiClient('nodeapi');